import React, { lazy, Suspense } from "react";

// Lazy load every step component
const ContactInformation = lazy(() => import("../steps/ContactInformation"));
const FullName = lazy(() => import("../steps/FullName"));
const YourIncome = lazy(() => import("../steps/YourIncome"));
const YourSalaryInsurance = lazy(() => import("../steps/YourSalaryInsurance"));
const StudyPlusEducationInfo = lazy(
    () => import("../steps/StudyPlusEducationInfo")
);
const OccupationJob = lazy(() => import("../steps/OccupationJob"));
const AKasseHoursAndEducation = lazy(
    () => import("../steps/AKasseHoursAndEducation")
);
const AKasseMembershipType = lazy(
    () => import("../steps/AKasseMembershipType")
);
const YourSituation = lazy(() => import("../steps/YourSituation"));
const Payment = lazy(() => import("../steps/Payment"));
const PriceOfferAndCoverage = lazy(
    () => import("../steps/PriceOfferAndCoverage")
);
const Summary = lazy(() => import("../steps/Summary"));
const MembershipType = lazy(() => import("../steps/MembershipType"));
const AKassePreviousFundInformation = lazy(
    () => import("../steps/AKassePreviousFundInformation")
);
const AKasseRecentGraduateJobAndEducation = lazy(
    () => import("../steps/AKasseRecentGraduateJobAndEducation")
);
const FromMos = lazy(() => import("../steps/FromMos"));

const getStep = (props) => {
    return renderStep(props);
};

const renderStep = (props) => {
    const key = `${props.Component}.${props.Variant || 0}`;
    switch (props.Component) {
        case "FromMos":
            return <FromMos key={key} {...props} />;
        case "FullName":
            return <FullName key={key} {...props} />;
        case "MembershipType":
            return <MembershipType key={key} {...props} />;
        case "ContactInformation":
            return <ContactInformation key={key} {...props} />;
        case "YourSituation":
            return <YourSituation key={key} {...props} />;
        case "Occupation":
            return <OccupationJob key={key} {...props} />;
        case "StudyPlusEducationInfo":
            return <StudyPlusEducationInfo key={key} {...props} />;
        case "YourIncome":
            return <YourIncome key={key} {...props} />;
        case "YourSalaryInsurance":
            return <YourSalaryInsurance key={key} {...props} />;
        case "Summary":
            return <Summary key={key} {...props} />;
        case "PriceOfferAndCoverage":
            return <PriceOfferAndCoverage key={key} {...props} />;
        case "Payment":
            return <Payment key={key} {...props} />;
        case "AKasseHoursAndEducation":
            return <AKasseHoursAndEducation key={key} {...props} />;
        case "AKasseMembershipType":
            return <AKasseMembershipType key={key} {...props} />;
        case "AKassePreviousFundInformation":
            return <AKassePreviousFundInformation key={key} {...props} />;
        case "AKasseRecentGraduateJobAndEducation":
            return <AKasseRecentGraduateJobAndEducation key={key} {...props} />;
        default:
            return null;
    }
};

export default getStep;
